import { StopWatch } from "../common/Icons";

const HowToApply = () => {
  const applySteps = [
    {
      title: "Confirm your profile",
      description: "We auto-fill from your Edvia profile.",
      time: "5 Min",
    },
    {
      title: "Upload documents",
      description: "Marksheets, passport, English Test, SOP, LORs.",
      time: "10 Min",
    },
    {
      title: "Pay application fee",
      description: "As per requirement",
      time: "2 Min",
    },
    {
      title: "Submit",
      description: "Edvia admission officers will reviews before sending.",
      time: "1 Min",
    },
    {
      title: "Wait for offer",
      description: "Conditional/unconditional depends case to case",
      time: "7-14 Days",
    },
  ];
  return (
    <div className="pt-8 md:pt-10 lg:pt-12 xl:pt-[56px]">
      <p className="text-lg md:text-xl lg:text-2xl font-semibold mb-[18px] md:mb-5 lg:mb-6">
        How to apply
      </p>
      <div className="flex flex-col gap-3">
        {applySteps.map((step, index) => (
          <div
            key={index}
            className="bg-white border border-[#D0C4FF] rounded-[12px] p-4 sm:p-5 flex items-center justify-between"
          >
            <div className="flex md:items-center gap-1 md:gap-3 lg:gap-[18px] flex-col md:flex-row">
              <div className="size-[32px] md:size-[40px] lg:size-[48px] bg-[#1776F0] rounded-full flex items-center justify-center">
                <p className="ff_poppins text-white text-xs sm:text-sm md:text-lg lg:text-xl xl:text-2xl font-semibold">
                  {index + 1}
                </p>
              </div>
              <div>
                <p className="text-base md:text-lg lg:text-xl font-semibold">
                  {step.title}
                </p>
                <p className="text-xs ff_poppins text-[#5C5C5C] md:mt-2">
                  {step.description}
                </p>
              </div>
            </div>
            <div className="rounded-full bg-[#FFE9CD] py-2 px-4 flex items-center gap-2 sm:gap-[10px]">
              <span className="size-[16px] md:size-[20px] lg:size-[24px]">
                <StopWatch className="size-[16px] md:size-[20px] lg:size-[24px]" />
              </span>
              <p className="text-sm md:text-base font-semibold ff_poppins text-[#EB9757] text-nowrap">
                {step.time}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default HowToApply;
